import { useEffect, useState } from "react"
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2'
import { toast } from 'react-toastify';

export const useActions = ({
    //------------- Generales
    marvarApi, dispatch, user, onLogout, location, paramsURL, toggle,
    //------------- globalStates
    globalStates,
    //------------- defalutData 
    defaultData,
    //------------- Helpers
    Helpers,
    //------------- Forms
    Forms,
    //------------- FetchData
    FetchData
}) => {

    const abrirModal = (_, title, compont, dataRequest) => {
        toggle(_, title, compont, dataRequest)
    }

    const cerrarModal = () => {
        toggle()
    }

    const handleClickPrintReport = () => {
        const { FilterForm } = Forms
        const { formState } = FilterForm

        const { startDate, endDate, idcategoria, currency_type, idcaja, movimiento_tipo } = formState

        if (!startDate) {
            alertMessage({ flag: 'FAIL', message: 'No es posible descargar sin especificar la fecha de inicio para generar el reporte' })
            return
        }

        if (!endDate) {
            alertMessage({ flag: 'FAIL', message: 'No es posible descargar sin especificar la fecha de fin para generar el reporte' })
            return
        }

        if (!idcategoria) {
            alertMessage({ flag: 'FAIL', message: 'No es posible descargar sin seleccionar la categoría para generar el reporte' })
            return
        }

        if (!currency_type) {
            alertMessage({ flag: 'FAIL', message: 'No es posible descargar sin seleccionar la moneda para generar el reporte' })
            return
        }

        if (!idcaja || idcaja === 'ALL') {
            alertMessage({ flag: 'FAIL', message: 'No es posible descargar sin seleccionar una caja para generar el reporte' })
            return
        }

        if (!movimiento_tipo) {
            alertMessage({ flag: 'FAIL', message: 'No es posible descargar sin seleccionar el tipo de movimiento para generar el reporte' })
            return
        }

        const { fetchTransactionsReport } = FetchData
        fetchTransactionsReport.setParamsToSearch({
            startDate,
            endDate,
            idcaja,
            movimiento_tipo
        })
        fetchTransactionsReport.executeFetch()

        abrirModal('', 'VISOR DE REPORTE', 'ReportViewer', {})
    }

    return Object.freeze({
        abrirModal,
        cerrarModal,
        handleClickPrintReport
    })
}

/**
 * Funcion para gestionar las alertas de toastify
 * @param {*} res : respuesta del API / custom (debe ser un json "{}")
 * @param {*} toggle : toggle de modal
 */
const alertMessage = (res, toggle) => {

    if (res) {
        const { flag, message } = res
        if (flag === 'OK') {
            toast.success(message, {
                position: "top-right",
                theme: "colored"
            })
            toggle && toggle()
        } else {
            toast.warn(message, {
                position: "top-right",
                theme: "colored",
                autoClose: false,
            })
        }
    } else {
        toast.warn('Error interno, notifique a Soporte técnico!.', {
            position: "top-right",
            theme: "colored",
            autoClose: false,
        })
    }
}